module.exports = __webpack_public_path__ + "img/home_banner.24e2970e.jpg";